export default {"src":"/_next/static/media/ID.7764131c.svg","height":34,"width":50,"blurWidth":0,"blurHeight":0};